const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/videos/new.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/admin/videos/new")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});